import IpcRouter from '@shared/ipc/IpcRouter.ts'
import type { OpenDialogReturnValue, OpenDialogOptions } from 'electron'

export type PreferredHourCycle = 'h11' | 'h12' | 'h23' | 'h24'

export interface BaseIpcRouterType {
  getPreferredHourCycle: () => Promise<PreferredHourCycle | null>
  updateOpenAtLogin: (openAtLogin: boolean) => Promise<void>
  restartApp: () => Promise<void>
  refreshCalendarEvents: () => Promise<void>
  showOpenDialog: (options?: OpenDialogOptions) => Promise<OpenDialogReturnValue>
  getFileIcon: (filePath: string) => Promise<string>
}

class BaseIpcRouter extends IpcRouter<BaseIpcRouterType> {
  constructor() {
    super('base', {
      getPreferredHourCycle: true,
      updateOpenAtLogin: true,
      restartApp: true,
      refreshCalendarEvents: true,
      showOpenDialog: true,
      getFileIcon: true,
    })
  }
}

export default BaseIpcRouter
